import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.momentumva.au";
const DEFAULT_IMAGE = "https://customer-assets.emergentagent.com/job_momentum-admin/artifacts/zj9v3atl_DSC05527-2.jpg";

export const SEO = ({ title, description, path = "", image }) => {
  const fullTitle = title ? `${title} | Momentum VA` : "Momentum VA — Outsourced Real Estate Support, Done Right";
  const url = `${SITE_URL}${path}`;
  const ogImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};
